module.exports = __webpack_public_path__ + "img/symbol_6.3495fbe5.png";